import View from "@components/View";
import Button from "@components/Button";
import { useUrlMapper } from "@src/contexts/URLMapperContext";
import { platform } from "@playroomkit/pr-common";
import { StoreSkuItem } from "@playroomkit/pr-wars-data";
import { useMemo } from "react";

interface VipPassGridItemProps extends StoreSkuItem {
  onClick: (id: string) => void;
  showPrice: (price: string | number) => string;
}

export const VipPassGridItem = (props: VipPassGridItemProps) => {
  const { sku_id, price, onClick, purchased, metadata, showPrice, free } =
    props;
  const urlMapper = useUrlMapper();

  const label = useMemo(() => {
    if (free) return "Claimed";
    if (purchased) return "Purchased";
    if (!sku_id) return "Coming Soon";
    return null;
  }, [purchased, free, sku_id]);

  return (
    <View
      className={`relative w-full max-h-[23rem] transition col-span-full ${
        !purchased ? "hover:scale-105" : ""
      }`}
    >
      <img
        src={urlMapper.mapUrl(metadata?.bannerImage ?? "")}
        alt="vip-access-banner"
        className="w-full h-full object-contain"
      />
      {/* Neon Subscription isn't implemented yet */}
      {((price && platform.isRunningInDiscord) || label) && (
        <View
          enableEventCapturing
          onClick={() => {
            if (purchased) return;
            onClick(sku_id ?? "");
          }}
          className={`absolute right-0 min-w-40 ${
            purchased ? "bottom-12" : "bottom-8"
          }`}
        >
          <div className="rounded-xl p-1 inline-block bg-[#079902] shadow-[0_2px_0_0_#047A00] w-full">
            <Button className="font-[Slackey] border-none outline-none text-base rounded-lg px-4 py-1 flex items-center justify-center transition-all whitespace-nowrap text-black bg-[#31EC2A] w-full gap-4">
              {label ? (
                <span className="text-xl">{label}</span>
              ) : (
                <>
                  {(metadata as any)?.oldPrice && (
                    <div className="text-[#079902] text-2xl line-through">
                      ${(metadata as any).oldPrice}
                    </div>
                  )}
                  <div className="text-align">
                    <div className="text-3xl">{showPrice(price ?? "")}</div>
                    <div className="text-xs">/month</div>
                  </div>
                </>
              )}
            </Button>
          </div>
        </View>
      )}
    </View>
  );
};
